const dataKeys = [
  { id: 1, type: 'cloth', fill: '#D2B36C' },
  { id: 2, type: 'misc', fill: '#FC6769' },
  { id: 3, type: 'trash', fill: '#7DA3A5' },
]

export { dataKeys }
